import { render } from "./InventoryItemTableItem.vue?vue&type=template&id=127c1eda"
import script from "./InventoryItemTableItem.vue?vue&type=script&lang=js"
export * from "./InventoryItemTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__